'use client'
import React, { useMemo, useState } from "react";

const CollaborationSection = () => {
  const tabs = useMemo(
    () => [
      {
        id: "skilling",
        label: "Industry Skilling Partnerships",
        title: "Industry Skilling Partnership",
        points: [
          {
            icon: "/wise-lp/images/icons/bag.png",
            text: "Co-develop short-term and long-term skilling programmes aligned to job roles",
          },
          {
            icon: "/wise-lp/images/icons/certificate.png",
            text: "Deliver training at your centres with certification",
          },
          {
            icon: "/wise-lp/images/icons/doc.png",
            text: "Drive workforce readiness through customised content and delivery models",
          },
          {
            icon: "/wise-lp/images/icons/man.png",
            text: "Offer apprenticeships and employment pathways to learners",
          },
        ],
        image:
          "https://cdn.msu.edu.in/wise/industry-skill-partner.webp",
      },
      {
        id: "certifications",
        label: "Skill Certifications (Awarding Body)",
        title: "Skill Certifications (Awarding Body)",
        points: [
          {
            icon: "/wise-lp/images/icons/bag.png",
            text: "Offer nationally recognised skill certifications with NHEQF alignment",
          },
          {
            icon: "/wise-lp/images/icons/certificate.png",
            text: "Align training delivery with NSQF levels and industry competencies",
          },
          {
            icon: "/wise-lp/images/icons/doc.png",
            text: "Enable credit transfer for vertical mobility and academic progression",
          },
          {
            icon: "/wise-lp/images/icons/man.png",
            text: "Ensure compliance, audits, and continuous quality improvement",
          },
        ],
        image:
          "https://cdn.msu.edu.in/wise/awarding-body.webp",
      },
      {
        id: "campus",
        label: "Industry As Campus",
        title: "Industry As Campus",
        points: [
          {
            icon: "/wise-lp/images/icons/bag.png",
            text: "Provide on-the-job training in real industry settings",
          },
          {
            icon: "/wise-lp/images/icons/certificate.png",
            text: "Enable learners to earn a stipend while they gain skills",
          },
          {
            icon: "/wise-lp/images/icons/doc.png",
            text: "Integrate hands-on learning with credit based degree/diploma programs.",
          },
          {
            icon: "/wise-lp/images/icons/man.png",
            text: "Co-develop curriculum and assessments",
          },
        ],
        image:
          "https://cdn.msu.edu.in/wise/industry-campus.webp",
      },
    ],
    []
  );

  const [activeTab, setActiveTab] = useState(tabs[0].id);

  return (
    <section className="collab-section">
      <div className="container text-center">
        <h2 className="title fw-bold">How We Collaborate With Industry</h2>
        <div className="w-100 d-flex justify-content-center align-items-center">
          <p className="collab-subtitle">
            We work closely with industry to connect learning with real-world practice through flexible, outcome-focused partnership models
          </p>
        </div>

        <div className="d-flex justify-content-center gap-3 flex-wrap mb-5 tab-button-group">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              type="button"
              onClick={() => setActiveTab(tab.id)}
              className={`btn btn-outline-dark ${activeTab === tab.id ? "active" : ""}`}
              aria-pressed={activeTab === tab.id}
              aria-controls={tab.id}
            >
              {tab.label}
            </button>
          ))}
        </div>

        {tabs.map((tab) => (
          <div
            key={tab.id}
            className={`row g-6 tab-content-box equal-height ${activeTab === tab.id ? "" : "d-none"
              }`}
            id={tab.id}
            role="region"
            aria-hidden={activeTab !== tab.id}
          >
            <div className="col-lg-5">
              <div className="info-box text-start">
                <h4 className="mb-4 fw-bold wise-tabs-view-title">{tab.title}</h4>

                {tab.points.map((point, idx) => (
                  <p key={idx} className="wise-info-point">
                    <span className="info-box-icon">
                      <img src={point.icon} className="icon-bag" alt="" />
                    </span>
                    {point.text}
                  </p>
                ))}

                <a href="/partner-registration" className="partnership-btn mt-3">
                  Explore Partnership Opportunities <i className="fa-solid fa-arrow-right"></i>
                </a>
              </div>
            </div>

            <div className="col-lg-7 image-col">
              <img src={tab.image} alt={tab.title} />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CollaborationSection;
